export { default } from './volume-high'
